/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=6004b32c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6004b32c&lang=css"

import exportComponent from "/home/runner/work/gh-docs-frontend/gh-docs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__